import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Button from "../../../../componentes/button/button";
import { CustomDropdown } from "../../../../componentes/dropdown/CustomDropdown";
import InputMoney from "../../../../componentes/input/inputMoney";
import Textarea from "../../../../componentes/input/textarea";
import FilialService from "../../../../services/resource/filialService";
import SolicitacaoService from "../../../../services/resource/solicitacaoService";
import SolicitacaoCompraService from "../../../../services/resource/solicitacaoCompraService";
import { FornecedorCotacaoEditor, validarCotacao } from "./CotacaoCamposEditor";
import FinalizarPorEstoqueModal from "./FinalizarPorEstoqueModal";

const service = new SolicitacaoCompraService();
const solicitacaoService = new SolicitacaoService();
const filialService = new FilialService();

const ACAO_FINALIZAR_ESTOQUE = "FINALIZAR_ESTOQUE";

export default function EtapaCotacao({ solicitacao, detalheProcesso, onAcaoConcluida, onDepoisDeAgir, encaminhar, anexoObrigatorioNaEtapa, temAnexo, anexar, anexos }) {
    const [filiais, setFiliais] = useState([]);
    const [filialEntregaId, setFilialEntregaId] = useState(detalheProcesso?.filialEntregaId ?? null);
    const [fornecedores, setFornecedores] = useState(
        (detalheProcesso?.fornecedores || []).map(f => ({
            nome: f.nome,
            produtosCotados: f.produtosCotados.map(pc => ({
                produtoId: pc.produtoId, quantidade: pc.quantidade, valorUnitario: pc.valorUnitario, prazoEntrega: pc.prazoEntrega,
            })),
        }))
    );
    const [observacao, setObservacao] = useState(detalheProcesso?.observacaoCotacao ?? "");
    const [valorFinalCotacao, setValorFinalCompra] = useState(detalheProcesso?.valorFinalCotacao ?? "");
    const [enviando, setEnviando] = useState(false);
    const [salvandoRascunho, setSalvandoRascunho] = useState(false);
    const [produtoEmEstoque, setProdutoEmEstoque] = useState(false);
    const [modalEstoqueAberto, setModalEstoqueAberto] = useState(false);
    const [finalizandoEstoque, setFinalizandoEstoque] = useState(false);
    const [produtosExtras, setProdutosExtras] = useState([]);

    const produtosOriginais = detalheProcesso?.produtos || [];
    const produtos = [...produtosOriginais, ...produtosExtras];

    function adicionarProdutoExtra(produtoCatalogo) {
        const jaNaCotacao = produtosOriginais.some(p => p.produtoCatalogoId === produtoCatalogo.id)
            || produtosExtras.some(p => p.id === produtoCatalogo.id);
        if (jaNaCotacao) {
            toast.error("Este produto já está na cotação.");
            return;
        }
        const novo = { id: produtoCatalogo.id, nome: produtoCatalogo.nome, quantidade: 1, novo: true };
        setProdutosExtras(prev => [...prev, novo]);
        setFornecedores(prev => prev.map(f => ({
            ...f,
            produtosCotados: [...f.produtosCotados, { produtoId: novo.id, quantidade: novo.quantidade, valorUnitario: "", prazoEntrega: "" }],
        })));
    }

    function removerProdutoExtra(produtoId) {
        setProdutosExtras(prev => prev.filter(p => p.id !== produtoId));
        setFornecedores(prev => prev.map(f => ({
            ...f,
            produtosCotados: f.produtosCotados.filter(l => l.produtoId !== produtoId),
        })));
    }

    useEffect(() => {
        filialService.listarAtivas().then(res => setFiliais(res.data)).catch(() => setFiliais([]));
    }, []);

    const filialSelecionada = filiais.find(f => f.id === filialEntregaId);

    function removerFornecedor(index) {
        setFornecedores(fornecedores.filter((_, i) => i !== index));
    }

    function montarFornecedoresPayload() {
        const idsExtras = new Set(produtosExtras.map(p => p.id));
        return fornecedores.map(f => ({
            nome: f.nome,
            produtosCotados: f.produtosCotados.map(l => ({
                produtoId: idsExtras.has(l.produtoId) ? null : l.produtoId,
                produtoCatalogoId: idsExtras.has(l.produtoId) ? l.produtoId : null,
                quantidade: Number(l.quantidade),
                valorUnitario: Number(l.valorUnitario),
                prazoEntrega: l.prazoEntrega,
            })),
        }));
    }

    async function enviar() {
        const erro = validarCotacao({ filialEntregaId, fornecedores, valorFinalCotacao });
        if (erro) {
            toast.error(erro);
            return;
        }
        if (anexoObrigatorioNaEtapa && !temAnexo) {
            toast.error("É necessário anexar pelo menos um documento para concluir esta etapa.");
            return;
        }

        let usuarioEscolhidoId;
        try {
            usuarioEscolhidoId = await encaminhar("ENVIAR");
        } catch {
            return;
        }

        setEnviando(true);
        service.preencherCotacao(solicitacao.id, {
            filialEntregaId,
            fornecedores: montarFornecedoresPayload(),
            observacao,
            valorFinalCompra: Number(valorFinalCotacao),
            usuarioEscolhidoId,
        })
            .then(res => onAcaoConcluida("ENVIAR", res.data))
            .catch(error => console.error("Erro ao enviar cotação", error))
            .finally(() => setEnviando(false));
    }

    function salvarRascunho() {
        setSalvandoRascunho(true);
        service.salvarRascunhoCotacao(solicitacao.id, {
            filialEntregaId,
            fornecedores: montarFornecedoresPayload(),
            observacao: observacao || null,
            valorFinalCompra: valorFinalCotacao === "" ? null : Number(valorFinalCotacao),
        })
            .then(() => {
                toast.success("Rascunho salvo.");
                onDepoisDeAgir?.();
            })
            .catch(error => console.error("Erro ao salvar rascunho da cotação", error))
            .finally(() => setSalvandoRascunho(false));
    }

    function selecionarProdutoEmEstoque() {
        setProdutoEmEstoque(true);
        setModalEstoqueAberto(true);
    }

    function cancelarFinalizacaoEstoque() {
        if (finalizandoEstoque) return;
        setModalEstoqueAberto(false);
        setProdutoEmEstoque(false);
    }

    function confirmarFinalizacaoEstoque() {
        setFinalizandoEstoque(true);
        solicitacaoService.executarAcao(solicitacao.id, { acao: ACAO_FINALIZAR_ESTOQUE })
            .then(res => {
                setModalEstoqueAberto(false);
                onAcaoConcluida(ACAO_FINALIZAR_ESTOQUE, res.data);
            })
            .catch(error => {
                console.error("Erro ao finalizar solicitação por estoque", error);
                setProdutoEmEstoque(false);
                setModalEstoqueAberto(false);
            })
            .finally(() => setFinalizandoEstoque(false));
    }

    return (
        <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
                <span className="text-sm font-medium text-foreground/80">Produto já possui estoque?</span>
                <div className="flex gap-2">
                    <Button variant={produtoEmEstoque ? "green" : "white"} label="Sim" onClick={selecionarProdutoEmEstoque} />
                    <Button variant={!produtoEmEstoque ? "green" : "white"} label="Não" onClick={() => setProdutoEmEstoque(false)} />
                </div>
            </div>

            {!produtoEmEstoque && (
                <>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        <div className="flex flex-col gap-1.5">
                            <label className="text-sm font-medium text-foreground/80">Filial de Entrega <span className="text-destructive">*</span></label>
                            <CustomDropdown value={filialEntregaId} onChange={e => setFilialEntregaId(e.value)} options={filiais} optionValue="id" optionLabel="nome" placeholder="Selecione" filter />
                            {filialSelecionada && (
                                <div className="text-sm text-foreground bg-muted rounded-lg px-3 py-2 mt-1">
                                    <p>{[filialSelecionada.enderecoLogradouro, filialSelecionada.enderecoBairro].filter(Boolean).join(", ")}</p>
                                    <p>
                                        {[filialSelecionada.enderecoCidadeNome, filialSelecionada.enderecoEstadoNome].filter(Boolean).join("/")}
                                        {filialSelecionada.enderecoCep ? ` — CEP: ${filialSelecionada.enderecoCep}` : ""}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>

                    <div>
                        <label className="text-sm font-medium text-foreground/80 block mb-2">Fornecedores <span className="text-destructive">*</span></label>
                        <FornecedorCotacaoEditor
                            produtos={produtos}
                            fornecedores={fornecedores}
                            onChange={setFornecedores}
                            onRemover={removerFornecedor}
                            onAnexar={anexar}
                            anexos={anexos}
                            onAdicionarProduto={adicionarProdutoExtra}
                            onRemoverProduto={removerProdutoExtra}
                        />
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <Textarea
                            label="Observação"
                            value={observacao}
                            onChange={e => setObservacao(e.target.value)}
                            rows={2}
                            placeholder="Alguma informação relevante sobre a cotação"
                        />

                        <InputMoney
                            label="Valor final da Cotação"
                            required
                            locale="pt-BR"
                            value={valorFinalCotacao}
                            minFractionDigits={2}
                            maxFractionDigits={2}
                            mode="decimal"
                            onFocus={(e) => e.target.select()}
                            onChange={e => setValorFinalCompra(e.target.value)}
                            helpText="Valor final negociado com o fornecedor escolhido."
                        />
                    </div>

                    <div className="flex justify-end gap-2">
                        <Button variant="outline" label="Salvar rascunho" iconLeft="fa fa-save" loading={salvandoRascunho} disabled={enviando} onClick={salvarRascunho} />
                        <Button variant="blue" label="Enviar cotação" iconLeft="fa fa-paper-plane" loading={enviando} disabled={salvandoRascunho} onClick={enviar} />
                    </div>
                </>
            )}

            <FinalizarPorEstoqueModal
                visible={modalEstoqueAberto}
                solicitacao={solicitacao}
                enviando={finalizandoEstoque}
                onFechar={cancelarFinalizacaoEstoque}
                onConfirmar={confirmarFinalizacaoEstoque}
            />
        </div>
    );
}
